import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFooterComponent } from './custom-footer/custom-footer.component';
import { ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutConfig } from '@spartacus/storefront';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { CustomCopyrightComponent } from './custom-copyright/custom-copyright.component';
import { CustomUpdateProfileComponent } from './custom-update-profile/custom-update-profile.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLoginFormComponent } from './../custom-login/custom-login-form/custom-login-form/custom-login-form.component';
import { CustomForgotPasswordComponent } from '../custom-login/custom-forgot-password/custom-forgot-password.component';
import { CustomLanguageComponent } from './custom-language/custom-language.component';
import { BiometricAndSecurityComponent } from './biometric-and-security/biometric-and-security.component';
import { CommonconfirmpopupComponent } from '../commonconfirmpopup/commonconfirmpopup.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        FormsModule,
        I18nModule,
        ReactiveFormsModule,
        SharedModule,
        ConfigModule.withConfig({
            cmsComponents: {
                FooterNavigationComponent: {
                    component: CustomFooterComponent,
                },
                CategoryNavigationComponent: {
                    component: CustomHeaderComponent
                },
                CMSParagraphComponent: {
                    component: CustomCopyrightComponent
                },
                ReturningCustomerLoginComponent: {
                    component: CustomLoginFormComponent
                },
                // BreadcrumbComponent: {
                //   component: LoginBreadcrumbComponent,
                // },
                LanguageComponent: {
                    component: CustomLanguageComponent,
                },
                ForgotPasswordComponent: {
                    component: CustomForgotPasswordComponent
                }
            },
        }),
        ConfigModule.withConfig({
            layoutSlots: {
                header: {
                    lg: {
                        slots: [
                            'PreHeader',
                            //'SiteContext',
                            'SiteLinks',
                            'SearchBox',
                            'NavigationBar',
                        ],
                    },
                    xs: {
                        slots: [
                            'PreHeader',
                            //'SiteContext',
                            'SiteLinks',
                            'NavigationBar'
                        ],
                    },
                    slots: ['PreHeader', 'NavigationBar',
                        //'SiteContext',
                        'SiteLinks'],
                },
            }
        } as LayoutConfig),
        CustomFooterComponent, CustomUpdateProfileComponent, CustomHeaderComponent, CustomCopyrightComponent, CustomLanguageComponent, BiometricAndSecurityComponent, CommonconfirmpopupComponent,
    ]
})
export class CustomHeaderFooterModule { }
